'use client';

import { useState, useCallback, useEffect } from 'react';

var useResize = function () {
    var _a = useState(1024), windowSize = _a[0], setWindowSize = _a[1];
    var _b = useState(null), breakpoint = _b[0], setBreakpoint = _b[1];
    var getBreakpointFromWidth = useCallback(function (width) {
        var currentBreakpoint = 'md';
        // Check breakpoint by screen width
        if (width < 768) {
            currentBreakpoint = 'xs';
        }
        else if (width >= 768 && width <= 1024) {
            currentBreakpoint = 'sm';
        }
        else if (width > 1024 && width < 1300) {
            currentBreakpoint = 'md';
        }
        else if (width >= 1301 && width < 1440) {
            currentBreakpoint = 'lg';
        }
        else {
            currentBreakpoint = 'xl';
        }
        return currentBreakpoint;
    }, []);
    var callbackObserve = useCallback(function () {
        var screenWidth = window.innerWidth;
        var currentBreakpoint = getBreakpointFromWidth(screenWidth);
        // Detect if breakpoint change
        if (breakpoint !== null && breakpoint === currentBreakpoint) {
            return;
        }
        setWindowSize(screenWidth);
        setBreakpoint(currentBreakpoint);
    }, [breakpoint, getBreakpointFromWidth]);
    useEffect(function () {
        // on mount
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('resize', callbackObserve);
        // on Unmount
        return function () {
            window.removeEventListener('resize', callbackObserve);
        };
    }, [callbackObserve]);
    if (breakpoint === null) {
        if (typeof window === 'undefined') {
            return ['lg', windowSize];
        }
        var screenWidth = window.innerWidth;
        var calculatedBreakpoint = getBreakpointFromWidth(screenWidth);
        return [calculatedBreakpoint, screenWidth];
    }
    return [breakpoint, windowSize];
};

export { useResize as default };
//# sourceMappingURL=index.js.map
